import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { PaymentTransactionComponent } from './features/payment-transaction/payment-transaction.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'payment',
    component: PaymentTransactionComponent,
    canActivate: [AuthGuard],
  },
  // this path is lazy-loaded, this means the module will not be downloaded by the browser until the user visits the target route
  {
    path: '',
    // prevent loading this module for unauthorized users
    canLoad: [AuthGuard],
    // prevent access to child routes of this module for unauthorized users
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./features/demo/demo.module').then((m) => m.DemoModule),
  },
  // if no match is found, redirect to default route
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
